import React from "react";
import { Link } from "react-router-dom";
import { Star, ShieldCheck, MapPin, Languages } from "lucide-react";
import InitialAvatar from "@/components/InitialAvatar";

export default function SitterCard({ s }) {
  return (
    <Link
      to={`/babysitters/${s.slug || s.id}`}
      className="card-organic overflow-hidden group block"
      data-testid={`sitter-card-${s.id}`}
    >
      <div className="p-6 pb-4 flex items-start gap-4">
        <InitialAvatar name={s.name} size={64} />
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <h3 className="font-serif text-xl text-forest leading-tight truncate">{s.name}</h3>
              <p className="text-sm text-forest/70 mt-1 line-clamp-1">{s.headline || "Warm, dedicated caregiver"}</p>
            </div>
            <div className="text-right shrink-0">
              <div className="font-serif text-lg text-forest">${s.hourly_rate || "—"}</div>
              <div className="text-[10px] uppercase tracking-wider text-forest/50">per hour</div>
            </div>
          </div>
          <div className="flex items-center gap-3 text-xs text-forest/70 mt-2">
            <span className="flex items-center gap-1">
              <Star className="w-3.5 h-3.5 fill-gold text-gold" />
              <span className="font-medium">{s.rating_avg ? s.rating_avg.toFixed(1) : "New"}</span>
              {s.rating_count > 0 && <span className="text-forest/50">({s.rating_count})</span>}
            </span>
            <span className="flex items-center gap-1"><MapPin className="w-3 h-3" /> {s.city || s.postal_code || "—"}</span>
          </div>
        </div>
      </div>
      <div className="px-6 pb-6 pt-2 flex flex-wrap gap-1.5 border-t border-taupe/50">
        {s.verified && <span className="badge-gold"><ShieldCheck className="w-3 h-3" /> Verified</span>}
        {s.cpr_certified && <span className="badge-sage">CPR</span>}
        {s.police_check_certified && <span className="badge-sage">Police Check</span>}
        {s.languages?.slice(0, 3).map((l) => (
          <span key={l} className="badge-sage"><Languages className="w-3 h-3" />{l}</span>
        ))}
      </div>
    </Link>
  );
}
